if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );

          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);

              const buttonText = this.submitButton.querySelector('span');
              if (buttonText) buttonText.classList.add('hidden');

              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;

            /*
             * VLIEG-NAAR-WINKELWAGEN ANIMATIE
             */
            this.flyToCart();

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      flyToCart() {
        /*
         * Zoek het winkelwagenicoon van Dawn.
         */
        const cartIcon =
          document.querySelector('#cart-icon-bubble') ||
          document.querySelector('.header__icon--cart');

        if (!cartIcon) return;

        /*
         * Zoek de juiste productafbeelding.
         * Werkt voor normale productpagina's én productkaarten.
         */
        const productContainer =
          this.closest('.card-wrapper') ||
          this.closest('.product') ||
          this.closest('quick-add-modal') ||
          this.parentElement;

        let productImage = null;

        if (productContainer) {
          productImage =
            productContainer.querySelector('.card__media img') ||
            productContainer.querySelector('.product__media img') ||
            productContainer.querySelector('img');
        }

        /*
         * Extra fallback voor normale Dawn-productpagina.
         */
        if (!productImage) {
          productImage =
            document.querySelector('.product__media img') ||
            document.querySelector('.product-media-container img');
        }

        if (!productImage) {
          this.bounceCart(cartIcon);
          return;
        }

        const imageRect = productImage.getBoundingClientRect();
        const cartRect = cartIcon.getBoundingClientRect();

        /*
         * Maak een kopie van de productfoto.
         */
        const flyingImage = productImage.cloneNode(true);

        flyingImage.removeAttribute('srcset');
        flyingImage.removeAttribute('sizes');

        flyingImage.style.position = 'fixed';
        flyingImage.style.zIndex = '999999';
        flyingImage.style.pointerEvents = 'none';

        flyingImage.style.left = `${imageRect.left}px`;
        flyingImage.style.top = `${imageRect.top}px`;

        flyingImage.style.width = `${imageRect.width}px`;
        flyingImage.style.height = `${imageRect.height}px`;

        flyingImage.style.objectFit = 'cover';
        flyingImage.style.borderRadius = '10px';

        flyingImage.style.opacity = '1';

        flyingImage.style.transition =
          'left 700ms cubic-bezier(0.22, 0.61, 0.36, 1), ' +
          'top 700ms cubic-bezier(0.22, 0.61, 0.36, 1), ' +
          'width 700ms cubic-bezier(0.22, 0.61, 0.36, 1), ' +
          'height 700ms cubic-bezier(0.22, 0.61, 0.36, 1), ' +
          'opacity 700ms ease, ' +
          'transform 700ms cubic-bezier(0.22, 0.61, 0.36, 1)';

        document.body.appendChild(flyingImage);

        /*
         * Forceer browser om beginpositie te tekenen.
         */
        flyingImage.getBoundingClientRect();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const targetSize = 28;

            flyingImage.style.left =
              `${cartRect.left + cartRect.width / 2 - targetSize / 2}px`;

            flyingImage.style.top =
              `${cartRect.top + cartRect.height / 2 - targetSize / 2}px`;

            flyingImage.style.width = `${targetSize}px`;
            flyingImage.style.height = `${targetSize}px`;

            flyingImage.style.opacity = '0.15';
            flyingImage.style.transform = 'rotate(8deg) scale(0.8)';
          });
        });

        /*
         * Wanneer foto bij winkelwagen aankomt:
         * foto verwijderen + winkelwagen laten poppen.
         */
        setTimeout(() => {
          flyingImage.remove();
          this.bounceCart(cartIcon);
        }, 700);
      }

      bounceCart(cartIcon) {
        if (!cartIcon) return;

        cartIcon.animate(
          [
            {
              transform: 'scale(1)',
            },
            {
              transform: 'scale(1.22)',
            },
            {
              transform: 'scale(0.94)',
            },
            {
              transform: 'scale(1.08)',
            },
            {
              transform: 'scale(1)',
            },
          ],
          {
            duration: 400,
            easing: 'ease-out',
          }
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}